import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CreateDrawComponent } from './components/create-draw/create-draw.component';
import { CreatePollComponent } from './components/create-poll/create-poll.component';
import { DrawResultComponent } from './components/draw-result/draw-result.component';
import { DrawsComponent } from './components/draws/draws.component';
import { PollChartsComponent } from './components/poll-charts/poll-charts.component';
import { PollsComponent } from './components/polls/polls.component';
import { AuthRoleGuard } from './auth/role/auth-role.guard';

const routes: Routes = [
  /* { path: 'dashboard', component: RevenueDashboardComponent } */
  { path: '', component: PollsComponent },
  { path: 'polls', component: PollsComponent },
  { path: 'create-poll', component: CreatePollComponent },
  { path: 'edit-poll/:id', component: CreatePollComponent },
  { path: 'create-dublicate/:id', component: CreatePollComponent },
  { path: 'poll-chart/:id', component: PollChartsComponent },
  { path: 'draws', component: DrawsComponent, canActivate: [AuthRoleGuard], data: {role: 'Admin'}},
  { path: 'create-draw', component: CreateDrawComponent, canActivate: [AuthRoleGuard], data: {role: 'Admin'} },
  { path: 'draw-result/:id', component: DrawResultComponent, canActivate: [AuthRoleGuard], data: {role: 'Admin'} }, 
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
